var exports = {
  "ok": "boardView__OFP88J",
  "gX": "OmnibarContainer__E76Kv8",
  "Gd": "boardContainer__xD7rX8",
  "cL": "horizontalGroup__Nnnsmy",
  "rf": "horizontalGroupHeader__ypiW_3",
  "nC": "horizontalGroupContainer__sVasge",
  "ey": "horizontalGroupAreaContainer__MNFwZT",
};

module.exports = exports;
